// Custom styles for DatePicker
export const datePickerStyles = `
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker__input-container {
    width: 100%;
  }
  .react-datepicker {
    font-family: 'Open Sans', sans-serif;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
  .react-datepicker__header {
    background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    border-radius: 0.5rem 0.5rem 0 0;
  }
  .react-datepicker__day--selected {
    background-color: #2563eb;
    color: white;
  }
  .react-datepicker__day--keyboard-selected {
    background-color: #3b82f6;
    color: white;
  }
  .react-datepicker__day:hover {
    background-color: #dbeafe;
  }
  .react-datepicker__day--today {
    background-color: #fef3c7;
    color: #92400e;
    font-weight: bold;
  }
  
  /* Custom scrollbar styles */
  .scrollbar-hide {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
  }
  .scrollbar-hide::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
  }
`
